import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense, useEffect } from 'react';
import RedirectHandler from './components/RedirectHandler';
import RedirectHandlerForAbrirChat from './components/RedirectHandlerForAbrirChat';
import { useChatRuntime } from './hooks/useChatRuntime';
import { useAuthStore } from './stores/useAuthStore';
import { useSessionStore } from './stores/useSessionStore';
import { useSessionHeartbeat } from './hooks/useSessionHeartbeat';

const Home = lazy(() => import('./pages/Home'));
const Chat = lazy(() => import('./pages/Chat'));

export default function Router() {
  const user = useAuthStore((s) => s.user);
  const initializeAuth = useAuthStore((s) => s.initializeAuth);
  const logoutUser = useAuthStore((s) => s.logoutUser);
  const setLogoutHandler = useSessionStore((s) => s.setLogoutHandler);

  useChatRuntime(user);
  useSessionHeartbeat();

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  useEffect(() => {
    setLogoutHandler(logoutUser);

    return () => {
      setLogoutHandler(null);
    };
  }, [logoutUser, setLogoutHandler]);

  return (
    <Suspense fallback={(
      <div style={{
        display: 'flex', height: '100vh', justifyContent: 'center', alignItems: 'center',
      }}
      >
        Carregando...
      </div>
    )}
    >
      <Routes>
        <Route path="/" element={user && !user.needsPasswordReset ? <Chat /> : <Home />} />
        <Route path="/chat" element={user && !user.needsPasswordReset ? <Chat /> : <Home />} />
        <Route path="/send" element={user ? <RedirectHandler /> : <Home />} />
        <Route path="/abrirChat" element={user ? <RedirectHandlerForAbrirChat /> : <Home />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Suspense>
  );
}
